
import { useCartStorage } from './cart/useCartStorage';
import { useCartSupabase } from './cart/useCartSupabase';
import { useCartActions } from './cart/useCartActions';

export const useCartOperations = (userId: string, isAuthenticated: boolean, authLoading: boolean) => {

  // Use storage operations
  const {
    cartItems,
    setCartItems,
    promoCode,
    setPromoCode,
    appliedCredit,
    setAppliedCredit,
    isLoading,
    setIsLoading
  } = useCartStorage(userId);

  // Use Supabase operations
  const supabaseOperations = useCartSupabase(
    userId,
    isAuthenticated,
    setCartItems,
    setIsLoading,
    authLoading
  );

  // Use cart actions
  const actions = useCartActions(
    userId,
    isAuthenticated,
    setCartItems,
    setPromoCode,
    setAppliedCredit,
    supabaseOperations
  );
  
  return {
    cartItems,
    isLoading,
    promoCode,
    setPromoCode,
    appliedCredit,
    ...actions
  };
};
